import { useEffect } from 'react';
import { Route, Outlet } from 'react-router-dom';
import { ProtectedRoute } from 'ProtectedRoute';
import { SignInComponent } from './components/SignInComponent';
import { OnboardingHybridComponent } from './components/OnboardingHybridComponent';
import { OnboardingHybridQuestionaryComponent } from './components/OnboardingHybridQuestionaryComponent';
import { OnboardingHybridRegisterComponent } from './components/OnboardingHybridRegisterComponent';
import { OnboardingHybridLoginComponent } from './components/OnboardingHybridLoginComponent';
import { OnboardingHybridForgotPasswordComponent } from './components/OnboardingHybridForgotPasswordComponent';

export const ONBOARDING_ROUTES = {
    SIGN_IN: { path: '/sign-in' },
    HYBRID: { path: '/onboarding/hybrid' },
    HYBRID_QUESTIONARY: { path: '/onboarding/hybrid/questionary' },
    HYBRID_REGISTER: { path: '/onboarding/hybrid/register' },
    HYBRID_LOGIN: { path: '/onboarding/hybrid/login' },
    HYBRID_FORGOT_PASSWORD: { path: '/onboarding/hybrid/forgot-password' },
};

export function configureOnboardingRoutes() {
    return [
        {
            routes: ONBOARDING_ROUTES,
            config: {
                removeAppShell: true,
            },
        },
    ];
}

function OnboardingHybridLayout() {
    useEffect(() => {
        document.documentElement.classList.add('bg-black');
        return () => {
            document.documentElement.classList.remove('bg-black');
        };
    }, []);

    return <Outlet />;
}

export function getOnboardingRoutes() {
    return (
        <Route id="onboarding-routes" element={<Outlet />}>
            <Route
                path={ONBOARDING_ROUTES.SIGN_IN.path}
                element={
                    <ProtectedRoute accessPolicy="notLoggedIn">
                        <SignInComponent />
                    </ProtectedRoute>
                }
            />
            <Route element={<OnboardingHybridLayout />}>
                <Route
                    path={ONBOARDING_ROUTES.HYBRID.path}
                    element={
                        <ProtectedRoute accessPolicy="notLoggedIn">
                            <OnboardingHybridComponent />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={ONBOARDING_ROUTES.HYBRID_QUESTIONARY.path}
                    element={
                        <ProtectedRoute accessPolicy="notLoggedIn">
                            <OnboardingHybridQuestionaryComponent />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={ONBOARDING_ROUTES.HYBRID_REGISTER.path}
                    element={
                        <ProtectedRoute accessPolicy="notLoggedIn">
                            <OnboardingHybridRegisterComponent />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={ONBOARDING_ROUTES.HYBRID_LOGIN.path}
                    element={
                        <ProtectedRoute accessPolicy="notLoggedIn">
                            <OnboardingHybridLoginComponent />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={ONBOARDING_ROUTES.HYBRID_FORGOT_PASSWORD.path}
                    element={
                        <ProtectedRoute accessPolicy="notLoggedIn">
                            <OnboardingHybridForgotPasswordComponent />
                        </ProtectedRoute>
                    }
                />
            </Route>
        </Route>
    );
}
